<template>
  <div class="electronic-rent-money">
    <breadcrumb :breadcrumb="breadcrumb" />

    <div style="margin-top: 10px;">
      <el-tabs v-model="billTabName" @tab-click="billTabClick" type="card">
        <el-tab-pane label="充值账单" name="rechargeBill">
          <div class="search-line" style="margin-top: 10px;">
            <div class="btn-box">
              <!--              <button-cancel value="批量生成通知单" @cancel="batchDownloadNotice" style="margin-right: 10px;" v-if="permissionCodes.indexOf('013004003') !== -1" />-->
              <input-select selectTitle="缴费状态" style="margin-right: 10px;" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
              <!--        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出"/>-->
            </div>
            <input-search placeholder="住户名称/房间号" @search="searchKey" />
          </div>
          <table-main v-if="billTabName === 'rechargeBill'" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="rechargeOperationArr" @modifyInvoiceStatus="modifyInvoiceStatus" @statusChange="statusChange" @statusInfoChange="statusInfoChange" noticeType="3" :noticeUrl="noticeUrl" tableOperationWidth="200"/>
        </el-tab-pane>
        <el-tab-pane label="月度账单" name="monthlyBill">
          <div class="search-line" style="margin-top: 10px;">
            <div class="btn-box">
              <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">计费周期</span>
              <el-date-picker v-model="timevalue"  size="small" type="daterange" style="width: 280px;" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期"
                              align="right" value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <input-search placeholder="住户名称/房间号" @search="searchKey" />
          </div>
          <div class="search-line" style="margin-top: 10px;">
            <div class="btn-box">
              <input-select selectTitle="账单状态" style="margin-right: 10px;" :selectWidth="'120px'" :selectData="statusList" @search="search" selectKey="status" />
              <input-select selectTitle="缴费状态" style="margin-right: 10px;" :selectWidth="'120px'" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
              <input-select selectTitle="用水类型" style="margin-right: 10px;" :selectWidth="'120px'" :selectData="waterTypeList" @search="search" :selectKey="'waterType'" />
              <!--        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出"/>-->
            </div>
            <div class="btn-box">
              <button-upload :cathUrl="uploadUrl" :onSuccess="onUploadSuccess" @getpage="getPage" value="导入公摊水量" v-if="permissionCodes.indexOf('013008005') !== -1"/>
              <button-export :href="templateUrl" download="download.xls" value="模板下载" style="margin-right: 0;"/>
              <button-cancel value="生成账单" @cancel="showMonthBillDialog" v-if="permissionCodes.indexOf('013008006') !== -1" />
              <button-cancel value="批量生成通知单" @cancel="batchDownloadNotice" style="margin-right: 10px;" v-if="permissionCodes.indexOf('013008003') !== -1"/>
              <button-export
                :href="exportUrl"
                :beforeDownload="beforeDownload"
                style="margin: 0 0 0 8px"
                download="download.xls"
                value="导出"/>
              <!-- <input-search placeholder="住户名称/房间号" @search="searchKey" /> -->
            </div>
          </div>
<!--          <div class="search-line">-->
<!--            <div class="btn-box">-->
<!--              <button-cancel value="批量生成通知单" @cancel="batchDownloadNotice" style="margin-right: 10px;" v-if="permissionCodes.indexOf('013008003') !== -1" />-->
<!--              <input-select selectTitle="缴费状态" style="margin-right: 10px;" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />-->
<!--              &lt;!&ndash;        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出"/>&ndash;&gt;-->
<!--            </div>-->
<!--            <input-search placeholder="住户名称/房间号" @search="searchKey" />-->
<!--          </div>-->
          <table-main v-if="billTabName === 'monthlyBill'" :tableHead="tableHead2" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" @modifyInvoiceStatus="modifyInvoiceStatus" @statusChange="statusChange" @statusInfoChange="statusInfoChange" noticeType="4" :noticeUrl="noticeUrl" tableOperationWidth="200" />
        </el-tab-pane>
        <el-tab-pane label="房间账单" name="roomBill">
          <div class="search-line" style="margin-top: 10px;">
            <div class="btn-box">
              <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">计费周期</span>
              <el-date-picker v-model="timevalue"  size="small" type="daterange" style="width: 280px;" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期"
                              align="right" value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <input-search placeholder="住户名称/房间号" @search="searchKey" />
          </div>
          <div class="search-line" style="margin-top: 10px;">
            <div class="btn-box">
              <input-select selectTitle="账单状态" style="margin-right: 10px;" :selectWidth="'120px'" :selectData="statusList" @search="search" selectKey="status" />
              <input-select selectTitle="缴费状态" style="margin-right: 10px;" :selectWidth="'120px'" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
              <input-select selectTitle="用水类型" style="margin-right: 10px;" :selectWidth="'120px'" :selectData="waterTypeList" @search="search" :selectKey="'waterType'" />
              <!--        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出"/>-->
            </div>
            <div class="btn-box">
              <button-upload :cathUrl="uploadUrlRoom" :onSuccess="onUploadSuccess" @getpage="getPage" value="导入公摊水量" v-if="permissionCodes.indexOf('013008005') !== -1"/>
              <button-export :href="templateUrlRoom" download="download.xls" value="模板下载" style="margin-right: 0;"/>
              <button-cancel value="生成账单" @cancel="showMonthBillDialog" v-if="permissionCodes.indexOf('013008006') !== -1" />
              <button-cancel value="批量生成通知单" @cancel="batchDownloadNotice" style="margin-right: 10px;" v-if="permissionCodes.indexOf('013008003') !== -1"/>
              <button-export
                :href="exportUrlRoom"
                :beforeDownload="beforeRoomDownload"
                style="margin: 0 0 0 8px"
                download="download.xls"
                value="导出"/>
              <!-- <input-search placeholder="住户名称/房间号" @search="searchKey" /> -->
            </div>
          </div>
          <!--          <div class="search-line">-->
          <!--            <div class="btn-box">-->
          <!--              <button-cancel value="批量生成通知单" @cancel="batchDownloadNotice" style="margin-right: 10px;" v-if="permissionCodes.indexOf('013008003') !== -1" />-->
          <!--              <input-select selectTitle="缴费状态" style="margin-right: 10px;" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />-->
          <!--              &lt;!&ndash;        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出"/>&ndash;&gt;-->
          <!--            </div>-->
          <!--            <input-search placeholder="住户名称/房间号" @search="searchKey" />-->
          <!--          </div>-->
          <table-main v-if="billTabName === 'roomBill'" :tableHead="roomTableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" @modifyInvoiceStatus="modifyInvoiceStatus" @statusChange="statusChange" @statusInfoChange="statusInfoChange" noticeType="4" :noticeUrl="noticeUrl" tableOperationWidth="300" />
        </el-tab-pane>
      </el-tabs>
    </div>

<!--    <div class="search-line">-->
<!--      <div class="btn-box">-->
<!--        <button-cancel value="批量生成通知单" @cancel="batchDownloadNotice" style="margin-right: 10px;" v-if="permissionCodes.indexOf('013008003') !== -1" />-->
<!--        <input-select selectTitle="缴费状态" style="margin-right: 10px;" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />-->
<!--&lt;!&ndash;        <button-export :href="exportUrl" download="download.xls" :beforeDownload="beforeDownload" value="导出"/>&ndash;&gt;-->
<!--      </div>-->
<!--      <input-search placeholder="住户名称/房间号" @search="searchKey" />-->
<!--    </div>-->
<!--    <table-main :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" @modifyInvoiceStatus="modifyInvoiceStatus" @statusChange="statusChange" @statusInfoChange="statusInfoChange" noticeType="4" :noticeUrl="noticeUrl" tableOperationWidth="200" />-->

    <el-dialog title="通知单模板选择" :visible.sync="noticeDialogFormVisible" width="500px" class="contractDialogForm"
               v-loading="downloadNoticeLoading"
               element-loading-text="通知单生成中，请耐心等待"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <div v-for="item in noticeTemplateList" class="contractDialogLine" :key="item.templateName">
          <div>{{item.templateName}}</div>
          <div class="operationBox">
            <span style="margin-right: 20px;" @click="previewContract(item.path, item.fileName, item.code)">预览</span>
            <span @click="downloadContract(item.path, item.fileName, item.code)">下载</span>
          </div>
        </div>
        <div v-if="noticeTemplateList.length === 0" style="text-align: center;line-height: 30px;">暂无通知单模板</div>
      </div>
    </el-dialog>

    <el-dialog title="生成账单" :visible.sync="monthBillDialogVisible" width="600px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">计费周期：</span>
          </div>
          <el-select v-model="generateData.cycle" size="small" style="width: 280px">
            <el-option v-for="item in cycleList" :key="item.cycle" :label="item.cycle" :value="item.cycle"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">水费单价：</span>
          </div>
          <el-input v-model="generateData.unitPrice" size="small" style="width: 280px" >
            <template slot="append">元</template>
          </el-input>
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="monthBillDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmGenerateElectricMonthBill">确 认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Finance";
import { errorHandler } from "../../../utils/errorHandler";
import { bus } from "../../../utils/bus";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb,
  },
  name: "water-finance-bill",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧财务",
          name: "finance-over-view",
        },
        {
          value: "账单管理",
        },
      ],
      // addCustom: 'amount-add',
      exportUrl: "",
      uploadUrl:"",
      statusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "0",
          label: "未生成"
        },
        {
          key: "1",
          label: "已导入公摊"
        },
        {
          key: "2",
          label: "已生成"
        }
      ],
      payStatusList: [
        {
          key: "",
          label: "全部",
        }, {
          key: "0",
          label: "未缴费",
        }, {
          key: "1",
          label: "已缴费",
        }, {
          key: "2",
          label: "已退款",
        },
      ],
      waterTypeList: [
        {
          key: "",
          label: "全部",
        }, {
          key: "冷水",
          label: "冷水",
        }, {
          key: "热水",
          label: "热水",
        }
      ],
      tableHead: [
        {
          prop: "billNo",
          label: "账单编号",
        }, {
          prop: "enterpriseName",
          label: "住户名称",
        }, {
          prop: "roomNumber",
          label: "房间号",
        }, {
          prop: "waterFee",
          label: "金额(元)",
        }, {
          prop: "payStatusText",
          label: "缴费状态",
        }, {
          prop: "payTime",
          label: "缴费时间",
        }, {
          prop: 'invoiceStatus',
          label: '开票状态',
          width: '120px',
          statusOnPageChangeStatus: 'invoiceStatusChangeStatus',
          statusList: [
            {
              code: '0',
              name: '未开票'
            }, {
              code: '1',
              name: '已开票'
            }, {
              code: '2',
              name: '开票中'
            }
          ],
          changeStatus: true
        }, {
          prop: 'invoiceNo',
          label: '发票号',
          width: '180px',
          statusOnPageChangeStatus: 'invoiceStatusChangeStatus',
          statusAlreadyOnPageChangeStatus: 'invoiceStatus',
          changeInfo: true
        }
      ],
      tableHead2:[
        {
          prop: "billNo",
          label: "账单编号",
          width: "120px"
        },
        {
          prop: "enterpriseName",
          label: "住户名称",
          width: "180px"
        },
        {
          prop: "roomNumber",
          label: "房间号",
          width: "120px"
        },
        {
          prop: "statusText",
          label: "账单状态",
          width: "120px"
        },
        {
          prop: "waterType",
          label: "用水类型",
          width: "120px"
        },
        {
          prop: "unitPrice",
          label: "水费单价(元)",
          width: "120px"
        },
        {
          prop: "cycle",
          label: "计费周期",
          width: "200px"
        },
        {
          prop: "waterConsumption",
          label: "自用水量(吨)",
          width: "120px"
        },
        {
          prop: "commonWaterConsumption",
          label: "公摊水量(吨)",
          width: "120px"
        },
        {
          prop: "totalWaterConsumption",
          label: "总水量(吨)",
          width: "120px"
        },
        {
          prop: "waterFee",
          label: "金额(元)",
          width: "120px"
        },
        {
          prop: "payStatusText",
          label: "缴费状态",
          width: "120px"
        },
        {
          prop: "payTime",
          label: "缴费时间",
          width: "120px"
        },
        {
          prop: "invoiceStatus",
          label: "开票状态",
          width: "120px",
          statusOnPageChangeStatus: "invoiceStatusChangeStatus",
          statusList: [
            {
              code: "0",
              name: "未开票"
            },
            {
              code: "1",
              name: "已开票"
            },
            {
              code: "2",
              name: "开票中"
            }
          ],
          changeStatus: true
        },
        {
          prop: "invoiceNo",
          label: "发票号",
          width: "180px",
          statusOnPageChangeStatus: "invoiceStatusChangeStatus",
          statusAlreadyOnPageChangeStatus: "invoiceStatus",
          changeInfo: true
        }
      ],

      uploadUrlRoom: "",
      templateUrlRoom: "",
      noticeUrlRoom: "",
      exportUrlRoom: "",
      roomTableHead:[
        {
          prop: "billNo",
          label: "账单编号",
          width: "120px"
        },
        {
          prop: "roomNumber",
          label: "房间号",
          width: "120px"
        },
        {
          prop: "enterpriseName",
          label: "承租主体",
          width: "180px"
        },
        {
          prop: "statusText",
          label: "账单状态",
          width: "120px"
        },
        {
          prop: "waterType",
          label: "用水类型",
          width: "120px"
        },
        {
          prop: "unitPrice",
          label: "水费单价(元)",
          width: "120px"
        },
        {
          prop: "cycle",
          label: "计费周期",
          width: "200px"
        },
        {
          prop: "waterConsumption",
          label: "自用水量(吨)",
          width: "120px"
        },
        {
          prop: "commonWaterConsumption",
          label: "公摊水量(吨)",
          width: "120px"
        },
        {
          prop: "totalWaterConsumption",
          label: "总水量(吨)",
          width: "120px"
        },
        {
          prop: "waterFee",
          label: "金额(元)",
          width: "120px"
        },
        {
          prop: "payStatusText",
          label: "缴费状态",
          width: "120px"
        },
        {
          prop: "payTime",
          label: "缴费时间",
          width: "120px"
        },
        {
          prop: "invoiceStatus",
          label: "开票状态",
          width: "120px",
          statusOnPageChangeStatus: "invoiceStatusChangeStatus",
          statusList: [
            {
              code: "0",
              name: "未开票"
            },
            {
              code: "1",
              name: "已开票"
            },
            {
              code: "2",
              name: "开票中"
            }
          ],
          changeStatus: true
        },
        {
          prop: "invoiceNo",
          label: "发票号",
          width: "180px",
          statusOnPageChangeStatus: "invoiceStatusChangeStatus",
          statusAlreadyOnPageChangeStatus: "invoiceStatus",
          changeInfo: true
        }
      ],
      // {
      //   isLooking: true,
      //     label: '余额明细'
      // },
      operationArr: ["modifyInvoiceStatus", 'financeNotice'],
      // operationArr: ['delete'],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        payStatus: "",
        waterType:"",
      },
      noticeUrl: '',

      rentCode: "",
      rentName: "",
      personName: "",
      personPhone: "",
      money: "",

      settlementDataVisible: false,
      settlementData: {},

      accountCode: "",
      accountName: "",

      billTabName: "rechargeBill",
      rechargeOperationArr: ["modifyInvoiceStatus"],
      templateUrl:"",
      timevalue:[],
      monthBillDialogVisible:false,
      generateData: {
        cycle: "",
        unitPrice: ""
      },
      cycleList:[],

      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      downloadNoticeLoading: false,
      noticeDialogFormVisible: false,
      noticeTemplateList: [],
      currentDueOverData: {},
    };
  },
  created() {
    this.templateUrl = api.waterMonthBillTemplateUrl;
    this.noticeUrl = api.createWaterUrl
    this.uploadUrl = api.importWaterMonthBill;

    this.templateUrlRoom = api.waterRoomMonthBillTemplateUrl;
    this.uploadUrlRoom = api.importRoomWaterMonthBill;
    this.noticeUrlRoom = api.createRoomWaterUrl;

    this.accountName = bus.global.accountName;
    this.accountCode = bus.global.accountCode;
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage()
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportWaterBill}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&payStatus=${this.requestData.payStatus}&waterType=${this.requestData.waterType}&status=${this.requestData.status}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`;
    },

    beforeRoomDownload() {
      this.exportUrlRoom = `${api.exportRoomWaterBill}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&payStatus=${this.requestData.payStatus}&waterType=${this.requestData.waterType}&status=${this.requestData.status}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`;
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || '';
        this.requestData.endTime = this.timevalue[1] || '';
      } else {
        this.requestData.startTime = '';
        this.requestData.endTime = '';
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;

      let url="";
      if (this.billTabName === "rechargeBill") {
        url = api.getWaterRechargeBillPage;
      } else if (this.billTabName === "monthlyBill") {
        url = api.getWaterBillPage;
      }else {
        url = api.getRoomWaterBillPage
      }
      this.$axios
        .post(url, reqData)
        .then((res) => {
          let data = res.data.data.list;
          data.map((v) => {
            v.code = v.billNo
            v.invoiceStatusChangeStatus = true
            if (v.payStatus === '0') {
              v.payStatusText = '未缴费'
            } else if (v.payStatus === '1') {
              v.payStatusText = '已缴费'
            } else if (v.payStatus === '2') {
              v.payStatusText = '已退款'
            }
            if (v.status === "0") {
              v.statusText = "未生成";
            } else if (v.status === "1") {
              v.statusText = "已导入公摊";
            } else if (v.status === "2") {
              v.statusText = "已生成";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取信息失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },

    modifyInvoiceStatus (data) {
      // if (data.invoiceStatus === '1') {
      //   nError('已开票的不允许修改')
      //   return false
      // } else {
      //
      // }

      data.invoiceStatusChangeStatus = false
      this.currentLineData = data
    },
    // 修改开票状态
    statusChange (data) {
      this.currentLineData.invoiceStatus = data
      for (let i in this.currentLineData) {
        if (this.currentLineData[i] === '--') {
          this.currentLineData[i] = ''
        }
      }
      let url = "";
      if (this.billTabName === "rechargeBill") {
        url = api.updateWaterRechargeBill;
      } else if (this.billTabName === "monthlyBill") {
        url = api.updateWaterBill;
      }else {
        url = api.updateRoomWaterBill
      }
      if (data === '0' || data === '2') {
        this.currentLineData.invoiceNo = ''
        this.$axios.post(url, this.currentLineData)
          .then(res => {
            nSuccess('修改成功')
            this.getPage()
          })
          .catch(errorHandler('修改失败'))
      }
    },
    // 修改发票号
    statusInfoChange () {
      let url = "";
      if (this.billTabName === "rechargeBill") {
        url = api.updateWaterRechargeBill;
      }  else if (this.billTabName === "monthlyBill") {
        url = api.updateWaterBill;
      }else {
        url = api.updateRoomWaterBill
      }
      for (let i in this.currentLineData) {
        if (this.currentLineData[i] === "--") {
          this.currentLineData[i] = "";
        }
      }
      if (!this.currentLineData.invoiceNo) {
        nError('请输入发票号')
        return false
      }
      this.$axios.post(url, this.currentLineData)
        .then(res => {
          nSuccess('修改成功')
          this.getPage()
        })
        .catch(errorHandler('修改失败'))
    },

    // 批量修改发票状态
    updatePatchElectricConsumptionRecord () {
      let reqData = []
      let sumMoney = 0
      this.selectionArr.map(selection => {
        this.tableData.map(v => {
          if (selection === v.code && v.invoiceStatus === '0') {
            for (let i in v) {
              if (v[i] === '--') {
                v[i] = ''
              }
            }
            reqData.push(v)
            reqData[reqData.length - 1].invoiceStatus = '1'
            sumMoney = sumMoney + parseFloat(v.money)
          }
        })
      })
      if (reqData.length === 0) {
        nError('请选择未开票的充值记录')
        return false
      }
      this.$confirm(`本次开票总金额为：${sumMoney.toFixed(2)} 元，已开票的不计入在内，请核对信息`, '温馨提示', {
        type: 'info'
      })
        .then(() => {
          this.$axios.post(api.updatePatchElectricConsumptionRecord, reqData)
            .then(res => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(() => {
              errorHandler('修改失败')
              this.getPage()
            })
        })
        .catch(() => {
          this.getPage()
        })
    },

    // 批量生成通知单
    batchDownloadNotice () {
      if (this.selectionArr.length === 0) {
        nError('请先选择对应账单')
        return false
      }
      this.noticeDialogFormVisible = true
      this.getTemplateList()
    },

    // 获取催款单列表
    getTemplateList () {
      this.$axios.post(api.getTemplateList, {
        templateType: '4'
      })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.noticeTemplateList = data
          }
        })
        .catch(errorHandler('获取催款单失败'))
    },

    // 催款单预览
    previewContract (path, fileName, code) {
      this.downloadNoticeLoading = true
      this.$axios.post(api.createPatchWaterUrl, {
        billCodes: this.selectionArr,
        fileName: fileName,
        templateUrl: path,
        templateCode: code
      })
        .then(res => {
          this.downloadNoticeLoading = false
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data) {
              window.open('http://view.officeapps.live.com/op/view.aspx?src=' + data, '_blank')
            } else {
              nError('预览失败')
            }
          }
        })
        .catch(errorHandler('预览失败'))
        .then(() => {
          this.downloadNoticeLoading = false
        })

    },
    // 催款单生成并下载
    downloadContract (path, fileName, code) {
      this.downloadNoticeLoading = true
      this.$axios.post(api.createPatchWaterUrl, {
        billCodes: this.selectionArr,
        fileName: fileName,
        templateUrl: path,
        templateCode: code
      })
        .then(res => {
          this.downloadNoticeLoading = false
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data) {
              window.open(data, '_blank')
            } else {
              nError('地址无效')
            }
          }
        })
        .catch(errorHandler('生成失败'))
        .then(() => {
          this.downloadNoticeLoading = false
        })
    },
    billTabClick() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.requestData.status = "";
      this.getPage();
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.requestData.searchKey = "";
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    // 点击生成账单
    showMonthBillDialog() {
      let url = "";
      if (this.billTabName === "monthlyBill") {
        url = api.getWaterBillCycle;
      }else {
        url = api.getRoomWaterBillCycle;
      }
      this.$confirm("请确认是否已导入公摊水量？", "温馨提示", {
        type: "warning"
      })
        .then(() => {
          this.$axios
            .get(url, {})
            .then(res => {
              let data = res.data.data;
              this.cycleList = data || [];
              if (this.cycleList.length === 0) {
                nError("暂无可生成账单的计费周期");
              } else {
                this.generateData = {
                  cycle: "",
                  unitPrice: ""
                };
                this.monthBillDialogVisible = true;
              }
            })
            .catch(errorHandler("查询计费周期失败"));
        })
        .catch(() => {
          console.log("取消");
        });
    },

    // 确认生成账单
    confirmGenerateElectricMonthBill() {
      if (!this.generateData.cycle) {
        nError("请选择计费周期");
        return false;
      }
      if (!this.generateData.unitPrice) {
        nError("请输入水费单价");
        return false;
      }
      let url = "";
      if (this.billTabName === "monthlyBill") {
        url = api.generateWaterMonthBill;
      }else {
        url = api.generateRoomWaterMonthBill;
      }
      this.$confirm("账单生成后无法修改，请谨慎操作", "温馨提示", {
        type: "warning"
      })
        .then(() => {
          this.$axios
            .post(url, this.generateData)
            .then(res => {
              this.pageNum = 1;
              this.pageSize = 10;
              this.requestData.searchKey = "";
              this.monthBillDialogVisible = false;
              this.getPage();
            })
            .catch(errorHandler("生成账单失败"));
        })
        .catch(() => {
          console.log("取消操作");
        });
    }
  },
  watch: {
    timevalue () {
      this.getPage();
    }
  },
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
.form-line {
  margin: 5px 0 20px 0;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 130px;
  line-height: 32px;
  text-align: right;
}
.red {
  color: #ff0000;
}
</style>

<style lang="less">
.electronic-rent-money {
  .el-input__inner {
    padding: 0 0 0 15px;
  }
  .el-input--mini {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .el-dialog__header {
    text-align: left;
  }
  .contractDialogForm {
    .el-dialog__header {
      text-align: center;
    }
    .operationBox {
      span {
        cursor: pointer;
        color: #337ab7;
      }
      span:hover {
        color: #00A0E6;
      }
    }
    .contractDialogLine {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      line-height: 30px;
      padding: 0 15px;
    }
    .contractDialogLine:hover {
      background-color: #eeeeee;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Finance/WaterFinance/WaterFinanceBill.vue